import React from 'react';

const IconSearch = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    fill="none"
    viewBox="0 0 15 15"
  >
    <path
      fillRule="evenodd"
      d="M1.75 6.462a4.754 4.754 0 119.507 0 4.754 4.754 0 01-9.507 0zM6.504.208a6.254 6.254 0 103.68 11.31l3.013 3.012a.75.75 0 001.06-1.06l-2.974-2.975A6.254 6.254 0 006.503.208z"
      clipRule="evenodd"
    />
  </svg>
);

export default IconSearch;
